export const importCustomersStrings = {
  pageTitle: "Importar clientes desde CSV",
  csvHint: "Arrastra un archivo CSV aquí o selecciona uno",
  csvSelectButton: "Seleccionar archivo CSV",
  csvColumnsError: "El CSV debe tener columnas: name, phone, email",
  csvDropError: "Suelta un archivo CSV",
  distributeUsersLabel: "Usuarios para distribuir (physical)",
  importButton: "Importar clientes",
  distributeButton: "Distribuir",
  clearButton: "Limpiar",
  summaryLabel: "Resumen:",
  importedChip: "Importados",
  alreadyExistsChip: "Ya existen",
  pendingChip: "Pendientes",
  errorChip: "Errores",
  colName: "Nombre",
  colPhone: "Teléfono",
  colEmail: "Email",
  colAssignee: "Asignado a",
  colStatus: "Estado",
  statusPending: "Pendiente",
  statusImported: "Importado",
  statusAlreadyExists: "Ya existe",
  statusError: "Error",
  assigneeLabel: "Usuario asignado",
  distributeChipSuffix: "clientes",
} as const
